/* DE homepage showroom only. Existing deferred-media/video-component own playback and controls. */
(() => {
  const query = window.matchMedia('(max-width: 767px)');
  const update = () => {
    const templates = Array.from(document.querySelectorAll('template'));
    const videos = [
      ...document.querySelectorAll('video[data-ft-de-showroom]'),
      ...templates.flatMap((template) => Array.from(template.content.querySelectorAll('video[data-ft-de-showroom]')))
    ];
    videos.forEach((video) => {
      const source = query.matches ? video.dataset.ftMobile : video.dataset.ftDesktop;
      if (!source || video.getAttribute('src') === source) return;
      const connected = video.isConnected;
      const position = video.currentTime || 0;
      const resume = !video.paused && !video.ended;
      if (connected) {
        video.autoplay = false;
        const component = video.closest("video-component");
        if (component && !resume) component.pausedByUser = true;
      }
      video.setAttribute('src', source);
      if (!connected) return;
      video.addEventListener('loadedmetadata', () => {
        if (Number.isFinite(video.duration)) video.currentTime = Math.min(position, Math.max(0, video.duration - 0.05));
        if (resume) video.play().catch(() => { /* Native controls remain available. */ });
        else video.pause();
      }, { once: true });
      video.load();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  query.addEventListener('change', update);
})();
